@if (video) {
	<embed-video [accountLicense]="accountLicense" [params]="videoParams" [video]="video" (onEnded)="next()">
	</embed-video>
} @else {
	@if (!error) {
		<vb-loading-spinner flex="fill" flex-align="center" flex-justify="center" layout="row" [size]="'large'">
		</vb-loading-spinner>
	} @else {
		<div class="embed-video-unavailable" flex="fill" flex-align="center" flex-justify="center" layout="column">

			<div class="embed-video-warning">
				<span class="glyphicons warning_sign"></span>
				{{ 'Media_Videos_Embed_NoLongerAvailable' | translate }}
			</div>
			<button class="btn-icon-right" type="button" (click)="next()" [hidden]="playlist?.videos.length <= 1" vbBtnPrimary>
				{{ 'Next' | translate }}
				<span class="glyphicons chevron-right"></span>
			</button>
		</div>
	}
}

<!--Playlist-->
<video-playlist-carousel #playlistCarousel [currentVideoId]="video?.id" [videos]="playlist.videos" (onSelectionChanged)="selectVideo($event.videoId)">
</video-playlist-carousel>
